module.exports = __webpack_public_path__ + "media/images/official/special_workcation_14-a7f0e9fd821881f658c4ebdcac8d86ff.jpg";